
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add_bank",
      function () {
        return require("private-next-pages/add_bank.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add_bank"])
      });
    }
  